import { IAnnouncementAttribute } from './types';

// Schema LOCALĂ a atributelor de anunț — oglindește AnnouncementCreateDto (required:
// title / subtitle / description / priorityId · optional: typeId / statusId). BE nu
// expune un endpoint de atribute (`api/announcements/attributes` nu există), deci schema
// e sursa unică pentru builder-ul de formular. Layout-ul tabelului vine din table-config.
const FALLBACK_ANNOUNCEMENT_ATTRIBUTES: IAnnouncementAttribute[] = [
	{
		key: 'title',
		label: 'Nume anunț',
		value: '',
		regex: '^[\\s\\S]{1,200}$',
		dataType: 'text'
	},
	{
		key: 'subtitle',
		label: 'Subtitlu',
		value: '',
		regex: '^[\\s\\S]{1,300}$',
		dataType: 'text'
	},
	{
		key: 'description',
		label: 'Descriere',
		value: '',
		regex: '^[\\s\\S]+$',
		dataType: 'text'
	},
	{ key: 'priorityId', label: 'Prioritate', value: null, regex: '^\\d+$', dataType: 'number' },
	{ key: 'typeId', label: 'Tip anunț', value: null, regex: null, dataType: 'number' },
	{ key: 'statusId', label: 'Status', value: null, regex: null, dataType: 'number' }
];

export { FALLBACK_ANNOUNCEMENT_ATTRIBUTES };
